export default "__VITE_ASSET__xgBwR_$6__"